import React from 'react';
import PropTypes from 'prop-types';

import styles from './GwpProducts.module.scss';

const GwpProducts = ({ children }) => (
  <div className={styles.gwpZone}>
    <div className={styles.gwpContent}>
      <div className={styles.gwpHeader}>
        <h1>Get a FREE Gift</h1>
        <p>Receive a Free Mystery Gift With $100+ Purchase!*</p>
      </div>
      {children}
      <p className={styles.gwpLegal}>
        *Gift with purchase available while supplies last to members who add and
        maintain one of the minimum purchase amount thresholds ($100, $200, or
        $300 not including taxes or shipping) in their Summer Edit sale cart
        throughout the sale. Eligible members must add the gift to their cart.
        If your cart drops below the relevant threshold amount at any point
        during the sale, your gift will be downgraded or removed. If the gift
        you qualify for is unavailable, you can add a gift from the next
        available category for which you qualify. One gift per customer.{' '}
        <strong>
          will ship with your Fall Box and you must receive your Fall Box in
          order to receive the gift.**
        </strong>
      </p>
    </div>
  </div>
);

GwpProducts.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GwpProducts;
